// extracted by mini-css-extract-plugin
export default {"sec_heading":"WebLinks_sec_heading__pWbu3","wraper":"WebLinks_wraper__0Xj3c"};